<template>
    <div class="slider">
        <v-range-slider
            color="primary"
            track-color="lilac"
            thumb-color="white"
            height="20"
            v-model="range"
            :max="maxValue"
            :min="minValue"
            :step="1"
            :readonly="readonly"
            hide-details></v-range-slider>

        <div class="text-muted text-bold text-sm text-center">
            {{range[0]}}{{dataLabel}} - {{range[1]}}{{dataLabel}}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                required: true
            },

            dataLabel: {
                type: String,
            },

            readonly: {
                type: Boolean,
                default: false
            },

            maxValue: {
                type: String,
                default: "100",
                required: false
            },

            minValue: {
                type: String,
                default: "0",
                required: false
            }
        },

        computed: {
            range: {
                get() {
                    return this.value
                },

                set(val) {
                    if (!this.readonly)
                        this.$emit('input', val)
                }
            }
        },
    }
</script>

<style scoped>

</style>
